// Utility function to safely check if a string starts with a pattern
export const safeStartsWith = (str, pattern) => {
  return typeof str === 'string' && str.startsWith(pattern);
};

// Utility function to safely check if a string includes a pattern
export const safeIncludes = (str, pattern) => {
  return typeof str === 'string' && str.includes(pattern);
};

// Utility function to normalize routes and prevent double slashes
export const normalizeRoute = (route) => {
  if (!route || typeof route !== 'string') return '/';
  
  // Remove any leading/trailing whitespace
  route = route.trim();
  
  // Ensure it starts with a single slash
  route = route.startsWith('/') ? route : `/${route}`;
  
  // Replace multiple consecutive slashes with single slash
  route = route.replace(/\/+/g, '/');
  
  return route;
};
